document.addEventListener("DOMContentLoaded", function () {

  var music = new Audio("//d3a1v57rabk2hm.cloudfront.net/newcatbox/booksea-copy-13/sounds/meow.mp3");
  music.preload = "auto";

  function handleInteraction() {
    music.currentTime = 0;

    music.play().catch(function (e) {
      console.warn("Playback failed:", e);
    });
  }

  // --- Parse query params ---
  var params = new URLSearchParams(window.location.search);

  var campaign = params.get("meow") || "";
  var email = params.get("email") || "";
  var response = params.get("response") || "";
  var subid = params.get("subid") || "";
  var confirm = params.get("confirm") || "";

  // --- Validate ---
  if (campaign && response) {
    var url = "https://script.google.com/macros/s/AKfycby21ZlelpoRh4DvO3QNsIqGOoclY1lDJaYjfFyhxxStaMjCzD_YwM_N2dIQUTAuKAwc/exec";

    var payload = new URLSearchParams();
    payload.append("Email", email);
    payload.append("Response", response);
    payload.append("Meow", campaign);
    payload.append("SubID", subid);
    payload.append("Confirm", confirm);

    fetch(url, {
      method: "POST",
      body: payload
    })
    .then(function () {
      console.log("Response Recorded");

      // only enable sound AFTER success
      document.body.addEventListener("click", handleInteraction, { once: true });
      document.body.addEventListener("touchstart", handleInteraction, { once: true });

    })
    .catch(function (err) {
      console.warn("Error submitting data:", err);
    });

  } else {
    console.log("Data not recorded");
    console.log(campaign, email, response, confirm);
  }

});